module.exports = __webpack_public_path__ + "static/icon6-85ccaba90bd51e8db8c6a2bb88225c9b.png";